export default function FinalCTASection() {
  return (
    <section className="relative py-14 md:py-20 overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-br from-[#C7510F] via-[#B8450A] to-[#2D2D2D]"></div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/15 via-transparent to-black/20"></div>

      <div className="relative z-10 max-w-4xl mx-auto px-4 md:px-6 text-center">
        <h2 className="text-2xl md:text-4xl font-bold text-white mb-6">
          Your Urgent Passport Situation Is Solvable
        </h2>
        <p className="text-base md:text-lg text-amber-50/90 max-w-3xl mx-auto mb-10 leading-relaxed">
          Most people who come to us thinking their passport situation is impossible are wrong. Whether your trip is in 5 days or 2 weeks, Fast Passport Center's registered couriers have daily reserved access to federal passport agencies and 20+ years of urgent passport experience. Start your order now or call us — we'll tell you exactly what's possible for your travel date.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-8">
          <a
            href="https://fastpassportcenter.com/checkout/"
            className="whitespace-nowrap inline-flex items-center gap-2 px-8 py-4 bg-[#F59E0B] hover:bg-[#D97706] text-[#2D2D2D] font-bold text-base md:text-lg rounded-md transition-colors cursor-pointer"
          >
            <i className="ri-passport-line text-xl"></i>
            Start My Urgent Passport Order
          </a>
          <a
            href="tel:8772530084"
            className="whitespace-nowrap inline-flex items-center gap-2 px-8 py-4 border-2 border-white/40 hover:border-white hover:bg-white/10 text-white font-semibold text-base md:text-lg rounded-md transition-colors cursor-pointer"
          >
            <i className="ri-phone-fill text-xl"></i>
            Call 877-253-0084
          </a>
        </div>

        <p className="text-sm text-amber-100/60 mb-10">
          Available Monday–Friday, 8AM–6PM EST. Start your order online anytime.
        </p>

        <div className="flex flex-wrap items-center justify-center gap-x-8 gap-y-3 text-white/65 text-xs md:text-sm">
          <span className="flex items-center gap-1.5 whitespace-nowrap">
            <i className="ri-government-fill"></i> Registered State Dept. Courier
          </span>
          <span className="flex items-center gap-1.5 whitespace-nowrap">
            <i className="ri-shield-check-line"></i> A+ BBB
          </span>
          <span className="flex items-center gap-1.5 whitespace-nowrap">
            <i className="ri-calendar-check-line"></i> Daily Agency Access
          </span>
          <span className="flex items-center gap-1.5 whitespace-nowrap">
            <i className="ri-history-line"></i> 20+ Years
          </span>
          <span className="flex items-center gap-1.5 whitespace-nowrap">
            <i className="ri-user-voice-line"></i> Real Humans Answer
          </span>
        </div>
      </div>
    </section>
  );
}